import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/svg/icon-view.svg';
import _imports_1 from '@/assets/images/svg/icon-timer.svg';
import _imports_2 from '@/assets/images/yulan.png';

const _withScopeId = n => (_pushScopeId("data-v-040c91f9"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "img_box"
};
const _hoisted_2 = {
  class: "btm_text"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_4 = {
  key: 0,
  class: "times"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "video_title"
};
const _hoisted_9 = {
  class: "text_ellipsis"
};
import { useStore } from "vuex";
export default {
  __name: 'VideoItem',
  props: ["dataItem"],

  setup(__props) {
    const props = __props;
    const store = useStore();

    const videoPlay = (item, type) => {
      store.commit("SET_LOGIN_POPUP", {
        show: true,
        type: "VideoDetails"
      });

      if (type === "yl") {
        item.isYl = true;
      } else {
        item.isYl = false;
      }

      store.commit("SET_VIDEO_DETAILS", item);
    };

    return (_ctx, _cache) => {
      const _component_my_image = _resolveComponent("my-image");

      return _openBlock(), _createElementBlock("div", {
        class: "video_item",
        onClick: _cache[1] || (_cache[1] = $event => videoPlay(props.dataItem))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_my_image, {
        url: props.dataItem.image
      }, null, 8, ["url"]), _createElementVNode("p", _hoisted_2, [_createElementVNode("span", null, [_hoisted_3, _createTextVNode(_toDisplayString(props.dataItem.count), 1)]), props.dataItem.times ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_hoisted_5, _createTextVNode(_toDisplayString(props.dataItem.times), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "yulan",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => videoPlay(props.dataItem, 'yl'), ["stop"]))
      }, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(props.dataItem.title), 1)])]);
    };
  }

};